import { useEffect, useRef } from 'react'
import styles from './Downloads.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import LeftContents from './LeftContents'
import { LeftContentDataType } from './types/types'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

gsap.registerPlugin(ScrollTrigger)

const leftContentData: LeftContentDataType = {
  titleVol: <>アプリ開発 発注前チェックリスト</>,
  alt: 'アプリ開発 発注前チェックリスト',
  readText: (
    <>
      アプリ開発の要件定義・予算・ベンダー選定に活用できる資料。発注前に役立つチェックリストもあり、迷ったら読むべき一冊
    </>
  ),
  imgLarge: '/images/img/download/application-development/thumbnail_application_dev.webp',
  imgCapture: '/images/img/download/application-development/capture_application_dev.webp',
  firstContentTitle: 'このような方におすすめ',
  firstHalf: (
    <>
      アプリ開発の担当者の方向けに、成功や失敗のポイントや発注前に準備しておくことなどをまとめた資料です。発注前のチェックリストもあり、アプリ発注前の担当者全ての方にご覧いただきたい資料となっています。要件定義・予算・ベンダー選定で迷ったら読むべき一冊です。
    </>
  ),
  secondContentTitle: 'この資料でわかること',
  secondHalf1: '「機能の詰め込みすぎ」や「丸投げ」による失敗の回避術',
  secondHalf2: '発注前に埋めるべき「30項目の事前チェックリスト」',
  secondHalf3: '最適なパートナーを見抜く「7つの選定基準」',
  secondHalf4: '新規開発とリニューアル、7つの観点で変わるベンダー選定の優先順位',
  secondHalf5: 'プロジェクトを「共創」に変える発注者のスタンス',
}

const DownloadApplicationDevelopment: React.FC = () => {
  const title_category = useRef<HTMLSpanElement>(null)
  const title_page = useRef<HTMLSpanElement>(null)
  useHubSpotGenerate('na1', '9395227', '9b77ef81-923f-44fb-90ce-d58302ef0c0a', '#hbspt')
  useEffect(() => {
    gsap.set([title_category.current, title_page.current, `.${styles.read_text}`, `.${styles.section}`], {
      opacity: 0,
      y: 50,
    })

    const timeline = gsap.timeline({
      defaults: {
        opacity: 0,
        y: 50,
        duration: 1,
        ease: Power4.easeOut,
      },
    })

    const commonTo = { opacity: 1, y: 0 }

    timeline
      .to(title_category.current, commonTo, 0.2)
      .to(title_page.current, commonTo, 0.5)
      .to(`.${styles.read_text}`, commonTo, 0.8)
      .to(`.${styles.section}`, commonTo, 1.1)
  }, [])

  return (
    <article className={`${styles.main} downloadArea`}>
      <section className={styles.contents}>
        <h1 className={styles.ttl}>
          <span ref={title_category}>Download</span>
          <span ref={title_page}>{leftContentData.titleVol}</span>
        </h1>
        <p className={styles.read_text}>{leftContentData.readText}</p>
        <section className={styles.section}>
          <LeftContents leftContentData={leftContentData} isSecondContent={true} />
          <div className={styles.content}>
            <div className={styles.title_group}>
              <p className={styles.whitepaper}>
                ご入力いただいたメールアドレス宛に、資料ダウンロード用URLを送付いたします。
              </p>
              <p className={styles.notice}>※ 全ての項目をご入力ください。</p>
            </div>
            <div id="hbspt"></div>
          </div>
        </section>
      </section>
      <MailmagazineLink />
    </article>
  )
}

export default DownloadApplicationDevelopment
